import { EagerLoadImages, wrapCollectionLayout } from "@quintype/components";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { deviceType } from "react-device-detect";
import { DfpComponent } from "../ads/dfp-component";
import { EMagazineWidgetBanner, Listing500India, ProfileRanking } from "../molecules";
import RankingEntities from "../molecules/RankingEntities";
import {
  ArrowElevenStories,
  ArrowFourColFiveStories,
  ArrowFourColGrid,
  ArrowFourColPortraitStories,
  ArrowFourColTwelveStories,
  ArrowFullScreenSlider,
  ArrowOneColStoryList,
  ArrowThreeColGrid,
  ArrowThreeColGridExchange,
  ArrowThreeColSevenStories,
  ArrowThreeColTwelveStories,
  ArrowTwoColFourStories,
} from "./arrow-rows";
import { FourColTenStories } from "./four-col-ten-stories";
import { FromOurMagazines } from "./from-our-magazines";
import { LatestMagazineIssues } from "./latest-magazine-issues";
import GoAdFreeWidgetRed from "../molecules/GoAdFreeWidgetRed";
import NewsletterWidget from "../molecules/NewsletterWidget";
import PodcastWidget from "../molecules/PodcastWidget";
import { FourColTenStoriesBudget } from "./four-col-ten-stories-budget";
import { CreatorOfTheMonth } from "./creator-of-the-month";

function wrapAd(Component) {
  const WrappedComp = function (props) {
    const network_id = get(props, ["config", "ads-config", "network_id"], {});
    const pageType = props.pageType;
    const isAdfreePage = get(props, ["config", "subscriber"]) === "true";
    const [inPageAdConfig, setInPageAdConfig] = useState({});
    const associatedMetadata = get(props, ["collection", "associated-metadata"], {});
    // Set in page ad config based on the device. Skip the check for server side rendering as the device width is not available.
    useEffect(() => {
      const device = deviceType === "browser" ? "desktop" : deviceType;
      const deviceSpecificAdPath = get(associatedMetadata, [`${device}_ad_unit_path`], "");
      const deviceSpecificAdConfigName = get(associatedMetadata, [`${device}_ad_config_name`], "");

      // Make this check for ads that are rendered on tablet
      if (deviceSpecificAdPath && deviceSpecificAdConfigName) {
        setInPageAdConfig({
          ...inPageAdConfig,
          ad_unit: deviceSpecificAdPath,
          ad_config_name: deviceSpecificAdConfigName,
        });
      }
    }, []);

    const path = `/${network_id}/${get(inPageAdConfig, ["ad_unit"], "")}`;
    const adSlotConfigName = `${get(inPageAdConfig, ["ad_config_name"], "")}`;
    return (
      <React.Fragment>
        <Component {...props} />
        {!isAdfreePage && inPageAdConfig.ad_unit && inPageAdConfig.ad_config_name && (
          <DfpComponent
            id={`${pageType}-collection-row-ad-${props.index}`}
            path={path}
            adSlotConfigName={adSlotConfigName}
          />
        )}
      </React.Fragment>
    );
  };
  if (Component.storyLimit) {
    WrappedComp.storyLimit = Component.storyLimit;
  }
  if (Component.nestedCollectionLimit) {
    WrappedComp.nestedCollectionLimit = Component.nestedCollectionLimit;
  }
  return WrappedComp;
}

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={(token) => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  ArrowFourColTwelveStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColTwelveStories))),
  ArrowThreeColGrid: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColGrid))),
  ArrowThreeColGridExchange: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColGridExchange))),
  ArrowFourColGrid: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColGrid))),
  ArrowElevenStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowElevenStories))),
  ArrowTwoColFourStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowTwoColFourStories))),
  ArrowFullScreenSlider: wrapAd(wrapEager(wrapCollectionLayout(ArrowFullScreenSlider))),
  ArrowOneColStoryList: wrapAd(wrapEager(wrapCollectionLayout(ArrowOneColStoryList))),
  ArrowThreeColSevenStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColSevenStories))),
  FourColTenStories: wrapAd(wrapEager(wrapCollectionLayout(FourColTenStories))),
  FourColTenStoriesBudget: wrapAd(wrapEager(wrapCollectionLayout(FourColTenStoriesBudget))),
  ArrowFourColFiveStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColFiveStories))),
  RankingEntities: wrapEager(wrapCollectionLayout(RankingEntities)), // Widget Row
  LatestMagazineIssues: wrapAd(wrapEager(wrapCollectionLayout(LatestMagazineIssues))),
  Next500India: wrapEager(wrapCollectionLayout(Listing500India)), // Widget Row
  Mnc500: wrapEager(wrapCollectionLayout(Listing500India)), // Widget Row
  EmergingCompanies: wrapEager(wrapCollectionLayout(Listing500India)), // Widget Row
  TrendingPeople: wrapEager(wrapCollectionLayout(ProfileRanking)), // Widget Row
  BestBSchools: wrapEager(wrapCollectionLayout(Listing500India)), // Widget Row
  Fortune500India: wrapEager(wrapCollectionLayout(Listing500India)), // Widget Row
  FortyUnderForty: wrapEager(wrapCollectionLayout(ProfileRanking)), // Widget Row
  MostPowerfulWomen: wrapEager(wrapCollectionLayout(ProfileRanking)), // Widget Row
  EMagazineWidgetBanner: wrapEager(wrapCollectionLayout(EMagazineWidgetBanner)), // Widget Row
  GoAdFreeWidget: wrapEager(wrapCollectionLayout(GoAdFreeWidgetRed)), // Widget Row
  NewsletterWidget: wrapEager(wrapCollectionLayout(NewsletterWidget)), // Widget Row
  PodcastWidget: wrapEager(wrapCollectionLayout(PodcastWidget)), // Widget Row
  ThreeColTwelveStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowThreeColTwelveStories))),
  ArrowFourColPortraitStories: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColPortraitStories))),
  FromOurMagazines: wrapAd(wrapEager(wrapCollectionLayout(FromOurMagazines))),
  defaultTemplate: wrapAd(wrapEager(wrapCollectionLayout(ArrowFourColGrid))),
  CreatorOfTheMonth: wrapAd(wrapEager(wrapCollectionLayout(CreatorOfTheMonth))),
};
